import dayjs from 'dayjs';
import { Card } from '../../../../../components/card/card';
import { Loader } from '../../../../../components/loader/loader';
import { Table } from '../../../../../features/table/table';
import { Dashboard } from '../dashboard';
import { useDashboardQr } from './use-dashboard-qr';
import { Link } from 'react-router-dom';
import { getBaseUrl } from '../../../../../store/api/utils.ts/stand';

export const DashboardQr = () => {
  const { chartsData, cards, isLoading, pagination, scans, getLocale } = useDashboardQr();

  return (
    <>
      <Dashboard chartsData={chartsData} cards={cards} />
      {isLoading && <Loader />}
      <div style={{ padding: 20 }}>
        <Card>
          <Table
            pagination={pagination}
            columnSettings
            cols={{
              qr: { label: 'QR', width: 200 },
              browser: { label: 'Браузер', width: 200 },
              os: { label: 'ОС', width: 200 },
              device: { label: 'Устройство', width: 200 },
              ip: { label: 'IP', width: 200 },
              createdAt: { label: 'Дата', width: 200 },
            }}
            rows={scans?.map((item) => ({
              qr: (
                <Link to={`${getBaseUrl()}/qr/${item.id}/main`} target="__blank">
                  {getLocale(item.name)}
                </Link>
              ),
              browser: item.browser,
              os: item.os,
              device: item.device_type,
              ip: item.ip,
              createdAt: dayjs(item.created_at).format('DD.MM.YYYY HH:mm'),
            }))}
          />
        </Card>
      </div>
    </>
  );
};
